import { Card, Table, Tabs, Text } from '@pega/cosmos-react-core';
import styled, { css } from 'styled-components';

export const InteractiveText = styled(Text)(({ theme, isDisabled = false }) => {
  return `
        color: ${isDisabled ? theme.base.colors.gray.dark : theme.base.palette.interactive};
    `;
});

export const StyledCard = styled(Card)(({ borderPositionCSS = 'border', theme }) => {
  return `
        ${borderPositionCSS}: 0.0625rem solid ${theme.components.card['border-color']};
        :hover{
            background-color: ${theme.base.palette['app-background']} !important;
        }
    `;
});

export const StyledTabs = styled(Tabs)(({ theme }) => {
  return `

    button:hover:not(:disabled)::after{
        background-color: ${theme.base.palette.interactive} !important;
    }

    button[aria-selected="true"] span{
        color: ${theme.base.palette.interactive};
        text-transform: initial;
    }
    
    button[aria-selected="true"]::after, button::after, button:focus::after, button:hover::after{
        background: ${theme.base.palette.interactive};
    }
    button:focus{
        border-color: ${theme.base.palette.interactive};
        border-top: none;
        border-left: none;
        border-right: none;
    }
    button[aria-selected="false"] span{
        text-transform: initial;
    }
`;
});

export const StyledTable = styled(Table)(({ hoverHighlight, theme }) => {
  return `
    
    border: 0.0625rem solid ${theme.base.colors.gray.medium};
    
    th {
        background-color: ${theme.base.colors.slate['extra-light']};
        border-left: 0.0625rem solid ${theme.base.colors.gray.medium};
    }

    td {
        padding: 0.1rem 1rem;
    }
    
    ${
      hoverHighlight &&
      `tbody tr:hover{
        background-color: ${theme.base.colors.blue['extra-light']};
    }`
    }
    `;
});

export const StyledTableNoPadding = styled(Table)(({ theme }) => {
  return `
      
      border: 0.0625rem solid ${theme.base.colors.gray.medium};
      
      th {
          padding: 0rem;
          background-color: ${theme.base.colors.slate['extra-light']};
          border-left: 0.0625rem solid ${theme.base.colors.gray.medium};
      }

      tbody tr td{
          padding: 0rem;
      }
  
      tbody tr td:first-of-type {
          padding-inline-start: 0rem;
      }
  
      tbody tr td:last-of-type {
          padding-inline-end: 0rem;
      }
      
      tbody tr:last-of-type td {
        padding-bottom: 0rem;
      }
      `;
});

export const tokenMaskerStyle = {
  padding: 0,
  border: 'none',
  boxShadow: 'none',
  background: 'none',
  height: 18,
  minHeight: 18,
  maxHeight: 18,
};

export const StyledCardPreview = styled.article(
  () =>
    css`
      box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14),
        0px 1px 3px 0px rgba(0, 0, 0, 0.12);
      bottom: 76px;
      right: 24px;
      z-index: 6000;
      height: 586px;
      position: fixed;
      max-height: calc(100vh - 90px);
      border: 1px solid #076bc9;
    `,
);

export const StyledDimension = styled.div(
  () => css`
    position: fixed;
    bottom: 54px;
    color: white;
    background: #076bc9;
    line-height: 0.9;
  `,
);

export const IconButtonStyle = styled.button(
  () => css`
    height: 2rem;
    padding: 5px;
    min-height: 2rem;
    min-width: 30px;
    margin: 5px;
    &:hover,
    &:focus {
      border: 0.0625rem solid transparent;
    }
  `,
);

export const lightGray = '1px solid rgb(207, 207, 207)';

export const StyledCardMessage = styled(Card)(({ theme }) => {
  return `
    border : 0.0625rem solid #939393;
    background-color: ${theme.base.palette['app-background']} !important;
    padding : 0.5rem;
    height: 100px;
    `;
});
